import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ValidationErrors } from "@angular/forms";
import { StateManagementService } from "../../../../providers/state-management/state-management.service";

/**
 * Generated class for the RadioInputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "radio-input",
  templateUrl: "radio-input.html",
})
export class RadioInputComponent implements OnInit, AfterViewInit {
  @Input() group: FormGroup;
  @Input() config: any;

  // Internal data model
  id: string;
  componentId: string;
  label: any;
  innerGroup: FormGroup;
  options: string[] = [];
  selected: string = null;
  default: string;
  required: boolean;
  disabled: boolean;
  readonly: boolean = false;
  orientation: "horizontal" | "vertical" = "vertical";
  bold: boolean = false;

  supportOther: boolean = false;
  supportOtherOverride: boolean;
  otherConfig: any;
  otherRules: any;
  maxLength: number;
  singleRow: boolean = false;
  painScreenSelection: any;
  constructor(
    public formBuilder: FormBuilder,
    public stateData: StateManagementService
  ) {
    // console.log('Hello RadioInputComponent Component');
  }

  ngOnInit(): void {
    // console.log("Checkbox input config: ", this.config);

    this.stateData.myData.subscribe((wongData) => {
      //console.log("value of data recieved is ",wongData);
    });
    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined ? this.config.label : this.config.id;
    this.singleRow =
      this.config.singleRow !== undefined ? this.config.singleRow : false;
    // console.log( "Radio label: ", this.label );
    if (this.label === "false") {
      this.label = false;
    }
    this.readonly = this.config.readonly;
    this.supportOther = this.config.supportOther;
    this.supportOtherOverride = this.config.supportOtherOverride;
    if (this.config.default) {
      this.default = this.config.default;
    }
    if (this.config.rules) {
      this.required = this.config.rules.required;
    }

    if (!this.config.options) {
      console.error("Cannot build checkbox input, no options found.");
    }

    this.group.addControl(this.id, this.formBuilder.control(null));
    this.innerGroup = this.formBuilder.group({});

    this.options = this.config.options;
    let formState = this.default !== undefined ? this.default : null;
    this.innerGroup.addControl("radio", this.formBuilder.control(formState));
    this.orientation = this.config.orientation || "vertical";
    this.bold = this.config.bold || false;

    if (this.supportOther || this.supportOtherOverride) {
      // console.log("Supporting other field, adding control.");
      this.otherConfig = {
        id: "other",
        label: false,
        placeholder: "other",
        rules: this.config.otherRules,
        readonly: this.readonly,
      };

      this.innerGroup.addControl("other", this.formBuilder.control(""));

      this.innerGroup.controls["other"].valueChanges.subscribe((data) => {
        if (data !== undefined && data !== "") {
          this.innerGroup.controls["radio"].setValue(undefined);
        }
      });
    }

    let updateValue = (data) => {
      if (data !== undefined && data !== this.getCurrentValue()) {
        // console.log( "Attempting to set!", this.options.indexOf( data ), typeof data  );

        if (typeof data === "number") {
          data = "" + data;
          // console.log( "Attempted to convert data: ", data, typeof data );
        }

        if (
          (this.supportOther || this.supportOtherOverride) &&
          this.options.indexOf(data) == -1
        ) {
          this.innerGroup.controls["other"].setValue(data);
          this.innerGroup.controls["radio"].setValue(undefined);
        } else {
          this.innerGroup.controls["radio"].setValue(data);
          if (this.supportOther || this.supportOtherOverride) {
            this.innerGroup.controls["other"].setValue(undefined);
          }
        }
      }
    };

    if (this.group.controls[this.id].value !== undefined) {
      updateValue(this.group.controls[this.id].value);
    }

    this.group.controls[this.id].valueChanges.subscribe((data) => {
      //console.log( "New radio value from parent group:--", this.id, data, this.getCurrentValue() );
      this.selected = data;
      updateValue(data);

      let outerDisabled = this.group.controls[this.id].disabled;
      if (outerDisabled !== this.disabled) {
        this.disabled = outerDisabled;
        if (!this.disabled) {
          this.innerGroup.enable();
        } else {
          this.innerGroup.disable();
        }
      }
      this.disabled = this.group.controls[this.id].disabled;
    });

    this.innerGroup.valueChanges.subscribe((data) => {
      this.group.controls[this.id].setValue(this.getCurrentValue());
      this.group.markAsDirty();

      this.group.controls[this.id].setErrors(this.getErrors());
    });

    this.innerGroup.controls["radio"].valueChanges.subscribe((data) => {
      if (
        (this.supportOther || this.supportOtherOverride) &&
        data !== undefined
      ) {
        this.innerGroup.controls["other"].setValue("");
      }
    });
  }

  ngAfterViewInit(): void {
    this.group.controls[this.id].setErrors(this.getErrors());

    // Errors can get lost when manually set
    // This is an overzealous approach to guarantee they get maintained
    this.group.valueChanges.subscribe((data) => {
      this.group.controls[this.id].setErrors(this.getErrors());
    });
  }

  getCurrentValue() {
    let radioVal = this.innerGroup.controls["radio"].value;
    if (!this.supportOther && !this.supportOtherOverride) {
      return radioVal;
    }
    let otherVal = this.innerGroup.controls["other"].value;
    if (otherVal === undefined || (otherVal === "" && radioVal == undefined)) {
      return undefined;
    } else {
      return otherVal === undefined || otherVal === "" ? radioVal : otherVal;
    }
  }

  getErrors(): ValidationErrors {
    let errors = {};
    if (
      this.required &&
      (undefined === this.getCurrentValue() || null === this.getCurrentValue())
    ) {
      errors["required"] = true;
    }
    if (
      this.innerGroup.controls["other"] &&
      this.innerGroup.controls["other"].invalid
    ) {
      errors["invalidOther"] = true;
    }
    // console.log( "Determined radio errors:", errors );
    return Object.keys(errors).length == 0 ? undefined : errors;
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/radio-input/radio-input.ts